<template>
  <div class="addresses" v-if="combinedMemberAddresses !== null">
    <div class="chosen-address" v-if="address">
      <Address :value="address" />
      <b-button variant="link" @click="choosing = true">Change</b-button>
    </div>
    <div class="new-address" v-else-if="adding">
      Enter new address:
      <address>
        <b-form-input v-model="newAddress.line1" class="inp" placeholder="Line1" />
        <b-form-input v-model="newAddress.line2" class="inp" placeholder="Line2" />
        <b-form-input v-model="newAddress.city" class="inp" placeholder="City" />
        <b-form-input v-model="newAddress.state" class="inp" placeholder="State" />
        <b-form-input v-model="newAddress.postcode" class="inp" placeholder="Zip" />
      </address>
      <b-button @click="addAddress" variant="default" size="lg">Done</b-button>
      <div class="error" v-if="addError">{{addError}}</div>
    </div>
    <div class="address-list" v-else>
      Choose address:
      <Address class="addr" @click="chooseAddress(addr)" :value="addr" v-for="addr in combinedMemberAddresses" :key="JSON.stringify(addr)" />
      <address class="addr" @click="startAdding">+ New Address</address>
    </div>
  </div>
</template>

<style scoped lang="scss">
@import '~scss/colors.scss';

address {
  text-align: left;
  padding: 0.5em;
  font-size: smaller;
  background-color: #f8f8f8;
  border: 1px solid #ccc;
  border-radius: 10px;
  cursor: pointer;
  margin: 0;
}
.chosen-address {
  address {
    border: 2px solid $gray-0;
  }
}
.address-list {
  address:hover {
    border-color: $gray-0;
  }
  address {
    margin-top: 0.5em;
  }
}
.addresses {
    margin-bottom: 1em;
}
</style>

<script>
import {mapActions, mapGetters} from "vuex";
export default {
  props: ['value'],
  data() {
    return {
      saving: false,
      adding: false,
      choosing: false,
      addError: '',
      newAddress: {
        line1: '',
        line2: '',
        city: '',
        state: '',
        postcode: '',
        country: 'US'
      }
    }
  },
  computed: {
    ...mapGetters(['combinedMemberAddresses']),
    address() {
      if (this.choosing) return null;
      return this.value;
    }
  },
  methods: {
    ...mapActions(['addTeamAddress']),
    chooseAddress(addr) {
      this.choosing = false;
      this.$emit('input', addr);
    },
    startAdding() {
      this.adding = true;
    },
    async addAddress() {
      // save new address
      try {
        let id = await this.addTeamAddress(this.newAddress);
        this.$emit('input', this.combinedMemberAddresses.find(a => a.id == id));
        // TODO animate?
        this.adding = false;
        this.choosing = false;
      } catch(e) {
        if (e.response && e.response.data) e = e.response.data;
        this.addError = e;
        return;
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/dashboard/team/EditMemberAddress.vue